export enum Motivations {
  MOTIVATION_ASSESSING = "assessing",
  MOTIVATION_BOOKMARKING = "bookmarking",
  MOTIVATION_CLASSIFYING = "classifying",
  MOTIVATION_COMMENTING = "commenting",
  MOTIVATION_DESCRIBING = "describing",
  MOTIVATION_EDITING = "editing",
  MOTIVATION_HIGHLIGHTING = "highlighting",
  MOTIVATION_IDENTIFYING = "identifying",
  MOTIVATION_LINKING = "linking",
  MOTIVATION_MODERATING = "moderating",
  MOTIVATION_QUESTIONING = "questioning",
  MOTIVATION_REPLYING = "replying",
  MOTIVATION_TAGGING = "tagging",
}

export enum CoursewareLessonTypes {
  LESSON_TYPE_STANDARD = "Standard Lesson",
  LESSON_TYPE_STITCHED = "Stitched lesson",
  LESSON_TYPE_LAB = "Lab Lesson",
}

export enum CoursewareElementTypes {
  ELEMENT_TYPE_ACTIVITY = "ACTIVITY",
  ELEMENT_TYPE_COMPONENT = "COMPONENT",
  ELEMENT_TYPE_FEEDBACK = "FEEDBACK",
  ELEMENT_TYPE_INTERACTIVE = "INTERACTIVE",
  ELEMENT_TYPE_PATHWAY = "PATHWAY",
  ELEMENT_TYPE_SCENARIO = "SCENARIO",
}

export enum PathwayTypes {
  PATHWAY_TYPE_LINEAR = "LINEAR",
  PATHWAY_TYPE_FREE = "FREE",
  PATHWAY_TYPE_GRAPH = "GRAPH",
  PATHWAY_TYPE_RANDOM = "RANDOM",
  PATHWAY_TYPE_ALGO_BKT = "ALGO_BKT",
}

export enum URN_TYPES {
  URN_EXTERNAL = "urn:external",
}

export const logLevel = {
  DEBUG: "DEBUG",
  ERROR: "ERROR",
  INFO: "INFO",
  WARN: "WARN",
};

export const transactions = ["SCREEN_TO_SCREEN"];

export const transactionSeq = {
  START: "START",
  STOP: "STOP",
  CONTINUE: "CONTINUE",
};
